<div id="mainPanel" class="hide" #mainPanel
  role="dialog" 
  aria-labelledby="filter-header"
  aria-modal="true"
  (keydown.escape)="closeFilter('mainPanel')">
  <div cdkTrapFocus cdkTrapFocusAutoCapture="true">
    <div class="filter-header-container">
      <h2 id="filter-header" class="filter-header">Filter By...</h2>
      <button
        type="button"
        (click)="closeFilter('mainPanel')"
        class="close-button btn btn-icon btn-secondary"
        aria-label="Close"
        #closeButton
      >
        <img src="../../../assets/img/close-black-icon.svg" alt="Close icon for filter modal" aria-hidden="true" />
      </button>  
    </div>
    <hr aria-hidden="true" />
  
    <div class="filter-container">
      <cdk-accordion>
        <!-- Question Type Accordion Item -->
        <cdk-accordion-item #questionAccordion="cdkAccordionItem">
          <h3 class="accordion-header">
            <div (click)="questionAccordion.toggle(); handleQuestionCheckboxStates(question)" 
                class="col-md-12 col-lg-12 col-xl-12 cq-box"
                tabindex="0"
                role="button"
                id="question-accordion-header"
                [attr.aria-expanded]="questionAccordion.expanded"
                aria-controls="question-content"
                (keydown)="accordionKeyHandler($event, questionAccordion, question)">
                <span id="question-label">Question type</span>  
                <span class="count-box">{{ qCheckBoxCount }}</span>
                <span class="sr-only">&nbsp;Filtered result</span>
              <div class="menu-icon">
                <i [class]="'fa ' + (questionAccordion.expanded ? 'fa-angle-up' : 'fa-angle-down')"
                   aria-hidden="true"></i>
              </div>
            </div>
          </h3>
          <div *ngIf="questionAccordion.expanded"
               id="question-content"
               role="region" 
               aria-labelledby="question-label"
               class="accordion-content">
            <div id="selectQuestion" class="select-all-container" [hidden]="!selectAllItems">
              <button 
                type="button" 
                (click)="toggleSelection()"
                class="select-all"
                #selectButton>
                Select all
              </button>
            </div>
            <div id="deselectQuestion" class="select-all-container" [hidden]="selectAllItems">
              <button 
                type="button" 
                (click)="toggleSelection()"
                class="select-all"
                #deselectButton>
                Deselect all
              </button>
            </div>
            <div role="group" aria-labelledby="question-label">
              <ul class="question-list">
                <li *ngFor="let question of questionList.itemInfo.typesAvailable; let i = index" class="question-item">
                  <label class="checkbox-label" for="{{ 'qCheckbox' + i }}">
                    <input
                      #qCheckbox
                      name="qCheckbox"
                      value="{{ question }}"
                      id="{{ 'qCheckbox' + i }}"
                      class="qCheckbox checkbox-right-margin"
                      type="checkbox"
                      [checked]="isQuestionTypeChecked(question)"
                      (change)="onFilterChange($event, question, 'question', '')"
                      (click)="clickCount($event, 'question', 0)"
                    />
                    <span>{{ question }}</span>
                  </label>
                </li>
              </ul>
            </div>
          </div>
          <input
            #inputQues          
            type="hidden"
            id="inputQues"
            value="0"
            [(ngModel)]="qCheckBoxCount"
          />
        </cdk-accordion-item>
    
        <!-- Category Accordion Items -->
        <cdk-accordion-item *ngFor="let question of questionList.itemInfo.categories; let i = index" #categoryAccordion="cdkAccordionItem">
          <h3 class="accordion-header">
            <div (click)="categoryAccordion.toggle(); handleQuestionCheckboxStates(question);" 
                class="col-md-12 col-lg-12 col-xl-12 cq-box"
                tabindex="0"
                role="button"
                [id]="'cat-header-' + i"
                [attr.aria-expanded]="categoryAccordion.expanded"
                [attr.aria-controls]="'category-content-' + i"
                (keydown)="accordionKeyHandler($event, categoryAccordion, question)">
              <span id="{{ 'catLabel' + i }}">
                {{ (question.name === 'Evergreen Release') ? question.name.replace('Evergreen ', '') : question.name }} 
              </span>
              <span #catCount id="{{ 'catCount' + i }}" class="count-box">0</span>
              <span class="sr-only">&nbsp;Filtered result</span>
              <div class="menu-icon">
                <i [class]="'fa ' + (categoryAccordion.expanded ? 'fa-angle-up' : 'fa-angle-down')"
                   aria-hidden="true"></i>
              </div>
            </div>
          </h3>
          <div *ngIf="categoryAccordion.expanded"
               [id]="'category-content-' + i"
               role="region" 
               [attr.aria-labelledby]="'catLabel' + i"
               class="accordion-content">
            <div [id]="'select' + i" class="select-all-container">
              <button
                type="button"
                  (click)="selectAll('category', i, question.name);"
                class="select-all"
                  #selectCategoryButton>Select all</button
                >
            </div>
            <div [id]="'deselect' + i" class="hide select-all-container">
              <button
                type="button"
                  (click)="deselectAll('category', i, question.name);"
                class="select-all"
                  #deselectCategoryButton>Deselect all</button
                >
            </div>
            <div role="group" [attr.aria-labelledby]="'catLabel' + i">
              <ul class="question-list">
                <li *ngFor="let ques of question.tags; let j = index" class="question-item">
                  <label class="checkbox-label" for="{{ 'cCheckbox' + i + '_' + j }}">
                    <input
                      #cCheckbox
                      value="{{ ques.id }}"
                      id="{{ 'cCheckbox' + i + '_' + j }}"
                      class="{{ 'cCheckbox' + i }} checkbox-right-margin"
                      type="checkbox"
                      [(ngModel)]="ques.checked"
                      (change)="onFilterChange($event, ques.id, 'category', question.name)"
                      (click)="clickCount($event, 'category', i)"
                    />
                    <span>{{ ques.tagName }}</span>
                  </label>
                </li>
              </ul>
            </div>
          </div>
          <input
            #inputCat
            type="hidden"
            [id]="'inputCat' + i"
            class="inputCat"
            value="0"
          />
        </cdk-accordion-item>
      </cdk-accordion>
    </div>
  </div>
  <div class="sr-only" role="status" id="filter-announcement" #filterAnnouncementRegion></div>
</div>

